// extracted by mini-css-extract-plugin
export default {"container":"TabButton_container__7oRR1","active":"TabButton_active__KHV-Q"};